import api from './axiosConfig';

/**
 * 通知服務
 */
const notificationService = {
  /**
   * 獲取用戶通知
   * @param {Object} options - 查詢選項
   * @param {number} options.page - 頁碼
   * @param {number} options.limit - 每頁限制
   * @param {boolean} options.unreadOnly - 僅未讀通知
   * @param {string} options.type - 通知類型
   * @returns {Promise} - 包含通知列表的響應
   */
  getNotifications: async (options = {}) => {
    const response = await api.get('/notifications', { params: options });
    return response.data;
  },

  /**
   * 獲取單個通知詳情
   * @param {string} id - 通知ID
   * @returns {Promise} - 包含通知詳情的響應
   */
  getNotificationById: async (id) => {
    const response = await api.get(`/notifications/${id}`);
    return response.data;
  },

  /**
   * 將通知標記為已讀
   * @param {string} id - 通知ID
   * @returns {Promise} - API響應
   */
  markAsRead: async (id) => {
    const response = await api.put(`/notifications/${id}/read`);
    return response.data;
  },

  /**
   * 將所有通知標記為已讀
   * @returns {Promise} - API響應
   */
  markAllAsRead: async () => {
    const response = await api.put('/notifications/read-all');
    return response.data;
  },

  /**
   * 獲取未讀通知計數
   * @returns {Promise} - 包含未讀數量的響應
   */
  getUnreadCount: async () => {
    const response = await api.get('/notifications/unread-count');
    return response.data;
  },

  /**
   * 刪除通知
   * @param {string} id - 通知ID
   * @returns {Promise} - API響應
   */
  deleteNotification: async (id) => {
    const response = await api.delete(`/notifications/${id}`);
    return response.data;
  },

  /**
   * 創建通告
   * @param {Object} announcementData - 通告數據
   * @param {string} announcementData.title - 通告標題
   * @param {string} announcementData.content - 通告內容
   * @param {string} announcementData.priority - 通告優先級（低、中、高）
   * @param {Array<string>} announcementData.targetGroups - 目標用戶組（如果有）
   * @param {Date} announcementData.expiryDate - 過期日期（可選）
   * @returns {Promise} - API響應，包含創建的通告
   */
  createAnnouncement: async (announcementData) => {
    const response = await api.post('/notifications/announcements', announcementData);
    return response.data;
  }
};

export default notificationService; 